
class MetricsLoader {
  constructor() {
    this.ready = false;
    this.buffer = [];

    if (typeof window !== 'undefined') {
      window.metricsLib = this;

      const { SEGMENT_KEY, DWH_ENDPOINT } = window.env;

      if (!DWH_ENDPOINT || !SEGMENT_KEY) {
        console.warn('DWH_ENDPOINT and SEGMENT_KEY must be defined. All metrics events will be ignored.');
      } else {
        this.setup({
          segmentKey: SEGMENT_KEY,
          dwhEndpoint: DWH_ENDPOINT
        });
      }
    }
  }

  setup({ segmentKey, dwhEndpoint }) {
    const self = this;
    window.metricsLib = new window.Auth0Metrics(segmentKey, dwhEndpoint, 'docs');
    window.metricsLib.ready(() => {
      self.ready = true;
      self.execBuffer();
    });
  }

  execBuffer() {
    this.buffer.forEach(item =>
      this[item.name](...item.args)
    );
  }

  track(...args) {
    if (!this.ready) {
      this.buffer.push({
        name: 'track',
        args
      });

      return;
    }

    window.metricsLib.track(...args);
  }

  page(...args) {
    if (!this.ready) {
      this.buffer.push({
        name: 'page',
        args
      });

      return;
    }

    window.metricsLib.page(...args);
  }
}

const metrics = new MetricsLoader();

// Register the first page view.
metrics.page();

export default metrics;
